import styled from 'styled-components';

export const IconFieldContainer = styled.div`
  display: grid;
  grid-template-columns: 16px auto;
  column-gap: 10px;
  align-items: center;
  color: ${({ theme }) => theme.colors.greenColor};
`;
